module.exports = __webpack_public_path__ + "static/img/jcst.2f5fa7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/jcst.png
// module id = B5lx
// module chunks = 0